

<header class="navbar">
  <div class="container navbar-inner">
    <!-- Logo -->
    <a routerLink="/" class="logo">
      <img src="assets/images/logo.jpeg" alt="BainesCredit Logo">
    </a>

    <!-- Centered Nav -->
    <div class="nav-center">
      <nav class="nav-links desktop" *ngIf="isLoggedIn | async">
        <a *ngFor="let link of navLinks"
           [routerLink]="link.page"
           routerLinkActive="active"
           [routerLinkActiveOptions]="{ exact: true }">
          <mat-icon>{{ link.icon }}</mat-icon>
          <span>{{ link.title }}</span>
        </a>
      </nav>
    </div>

    <!-- Right: User Profile + Logout -->
    <div class="actions" *ngIf="isLoggedIn | async">
      <div class="user-profile desktop-only">
        <mat-icon class="user-icon">person_outline</mat-icon>
        <span class="username" [matTooltip]="userName">{{ userName }}</span>
      </div>

      <a (click)="logout()" class="logout-link desktop-only">
        <mat-icon>logout</mat-icon>
        <span>Sign Out</span>
      </a>
    </div>

    <!-- Mobile Toggle -->
    <button mat-icon-button class="menu-toggle" (click)="toggleMobileMenu()">
      <mat-icon>menu</mat-icon>
    </button>
  </div>



  <!-- Mobile Menu Drawer -->
<div *ngIf="isMobileMenuOpen" class="mobile-menu-overlay" (click)="closeMobileMenu()">
  <div class="mobile-menu" (click)="$event.stopPropagation()">
    <!-- Enhanced Header with User Info -->
    <div class="mobile-menu-header">
      <div class="mobile-user-profile">
        <mat-icon class="user-icon">person</mat-icon>
        <div class="user-details">
          <div class="username">{{ userName }}</div>
          <div class="sign-out-link" (click)="logout(); closeMobileMenu()">
            Sign Out
          </div>
        </div>
      </div>
      <button mat-icon-button class="close-btn" (click)="closeMobileMenu()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <!-- Navigation Links -->
    <nav>
      <a *ngFor="let link of navLinks"
         [routerLink]="link.page"
         (click)="closeMobileMenu()"
         routerLinkActive="active-mobile">
        <mat-icon>{{ link.icon }}</mat-icon>
        <span>{{ link.title }}</span>
      </a>
    </nav>
  </div>
</div>
</header>